/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const star = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.452 1.277 2.082 4.125 4.007.397a.501.501 0 0 1 .31.855l-3.297 3.269 1.223 4.441a.506.506 0 0 1-.716.582l-4.063-2.012-4.056 2.01a.506.506 0 0 1-.716-.582L4.448 9.92l-3.3-3.268a.5.5 0 0 1 .311-.855L5.466 5.4l2.079-4.123a.51.51 0 0 1 .907 0v0Z"
    />
  </svg>
)
export default star
